"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainInfoFields = void 0;
exports.DomainInfoFields = [
    "domainName",
    "nameServer",
    "dnssec",
    "registrar",
    "registryExpiryDate",
    "creationDate",
    "updatedDate",
    "registryDomainId"
];
//# sourceMappingURL=domain.js.map